import { useState, useEffect } from 'react';
import PlacesComponent from './PlacesPage';
import MapComponent from './MapPage';
import EmailComponent from './InfoPage';
import { setOptions, importLibrary } from '@googlemaps/js-api-loader';

const AppView = () => {

    const [view, setView] = useState('places');
    const [address, setAddress] = useState(null);
    const [geoLat, setGeoLat] = useState(null);
    const [geoLng, setGeoLng] = useState(null);
    const [imageData, setImageData] = useState(null);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => 
    {
        if (!window.google) 
        {
            // If Production)
            setOptions({ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY });
            // If Development)
            //setOptions({ key: '123'})
            // Load in parallel, not sequentially
            Promise.all([
                importLibrary('places'),
                importLibrary('maps'),
                importLibrary('marker'),
            ]);
        }
        const checkIfMobile = () => { setIsMobile(window.innerWidth <= 768); };
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return () => { window.removeEventListener('resize', checkIfMobile); };
    }, []);

    function loadMapData(address, lat, lng) {
        setAddress(address);
        setGeoLat(lat);
        setGeoLng(lng);
        setView('map');
    }

    function loadImageData(img) {
        setImageData(img);
        setView('email');
    }

    return (
        <div>
            {view === 'places' && <PlacesComponent passData={loadMapData}/> }
            {view === 'map' && address !== null && geoLat !== null && geoLng !== null && (
                <MapComponent passData={loadImageData} passGeoLat={geoLat} passGeoLng={geoLng} isMobile={isMobile}/>
            )}
            {view === 'email' && address !== null && (
                <EmailComponent passAddress={address} passImage={imageData}/>
            )}
        </div>
    );
}

export default AppView;